var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#22b3b3;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.448,11.269a3.18,3.18,0,1,0,3.179,3.18A3.183,3.183,0,0,0,14.448,11.269Z",
    transform: "translate(-6.448 -6.448)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.056)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.317,3.4a.944.944,0,0,1-.944-.944V.944a.944.944,0,1,1,1.888,0v1.51A.944.944,0,0,1,21.317,3.4Z",
    transform: "translate(-20.373)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.056 12.601)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.317,37.215a.944.944,0,0,0-.944.944v1.51a.944.944,0,1,0,1.888,0v-1.51A.944.944,0,0,0,21.317,37.215Z",
    transform: "translate(-20.373 -37.215)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.491 2.553)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.558,8.647a.945.945,0,0,1,0-1.335l1.068-1.068a.944.944,0,0,1,1.335,1.335L33.894,8.647A.944.944,0,0,1,32.558,8.647Z",
    transform: "translate(-32.282 -5.967)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.552 10.491)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.646,32.56a.943.943,0,0,0-1.335,0L6.243,33.627a.944.944,0,1,0,1.335,1.335l1.068-1.069A.943.943,0,0,0,8.646,32.56Z",
    transform: "translate(-5.967 -32.283)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.601 7.056)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M37.215,21.317a.944.944,0,0,1,.944-.944h1.51a.944.944,0,1,1,0,1.888h-1.51A.944.944,0,0,1,37.215,21.317Z",
    transform: "translate(-37.215 -20.373)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.056)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.4,21.317a.944.944,0,0,0-.944-.944H.944a.944.944,0,1,0,0,1.888h1.51A.944.944,0,0,0,3.4,21.317Z",
    transform: "translate(0 -20.373)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.491 10.492)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.558,32.56a.945.945,0,0,1,1.335,0l1.068,1.068a.944.944,0,0,1-1.335,1.335L32.558,33.9A.943.943,0,0,1,32.558,32.56Z",
    transform: "translate(-32.282 -32.284)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.552 2.553)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.646,8.647a.944.944,0,0,0,0-1.335L7.578,6.244A.944.944,0,0,0,6.243,7.579L7.311,8.647A.943.943,0,0,0,8.646,8.647Z",
    transform: "translate(-5.967 -5.967)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSun);
export default __webpack_public_path__ + "static/media/icon-sun.faea7916dccda08034115795f8142458.svg";
export { ForwardRef as ReactComponent };